const API_VERSION = "v1";

export const getURLWithVersion = (url: string) => `/${API_VERSION}${url}`;
